module.exports = __webpack_public_path__ + "fonts/Adelle_BoldItalic.35c49abe.woff";